document.addEventListener("DOMContentLoaded", () => {
  if (typeof Fancybox !== "undefined") {
    // eslint-disable-next-line no-undef
    Fancybox.bind("[data-fancybox]", {
      Thumbs: false,
    });
  }
});

if (typeof ScrollTrigger !== "undefined") {
  ScrollTrigger.config({ ignoreMobileResize: true });
}

function purgeTriggersFor(element) {
  if (typeof ScrollTrigger === "undefined" || !element) {
    return;
  }
  ScrollTrigger.getAll().forEach((trigger) => {
    if (trigger.trigger === element) {
      try {
        trigger.kill();
      } catch { /* empty */ }
    }
  });
}

function forceRefreshAllTriggers() {
  if (typeof ScrollTrigger === "undefined") {
    return;
  }
  ScrollTrigger.getAll().forEach((trigger) => {
    try {
      trigger.refresh(0, 1);
    } catch {
      
      ScrollTrigger.isRefreshing = false;
    }
  });
}

function remeasureAllScrollTriggers() {
  forceRefreshAllTriggers();
}

function remeasureOnScrollSettle() {
  const last = window.scrollY;
  let frames = 0;
  const tick = () => {
    if (Math.abs(window.scrollY - last) > 1) {
      remeasureAllScrollTriggers();
      return;
    }
    frames += 1;
    if (frames < 40) {
      requestAnimationFrame(tick);
    }
  };
  requestAnimationFrame(tick);
}

window.addEventListener("load", () => {
  if (typeof ScrollTrigger === "undefined") {
    return;
  }
  const fontsReady =
    document.fonts && document.fonts.ready
      ? document.fonts.ready
      : Promise.resolve();
  fontsReady.then(() => {
    remeasureAllScrollTriggers();
    remeasureOnScrollSettle();
  });
});


window.addEventListener("pageshow", (event) => {
  if (event.persisted) {
    remeasureAllScrollTriggers();
  }
});

/* ===== ScrollTrigger refresh/kill safety net ===== */

let scrollTriggerBusy = 0;

function buildScrollTrigger(factory) {
  if (typeof ScrollTrigger === "undefined") {
    return null;
  }
  scrollTriggerBusy += 1;
  try {
    return factory();
  } catch {
    ScrollTrigger.isRefreshing = false;
    return null;
  } finally {
    scrollTriggerBusy -= 1;
  }
}

function refreshScrollTriggers(safe) {
  if (typeof ScrollTrigger === "undefined" || ScrollTrigger.isRefreshing) {
    return;
  }
  scrollTriggerBusy += 1;
  try {
    ScrollTrigger.refresh(safe);
  } catch {
    
    ScrollTrigger.isRefreshing = false;
  } finally {
    scrollTriggerBusy -= 1;
  }
}


const _pendingRemeasure = new Set();
let _remeasureQueued = false;


function remeasureScrollTrigger(trigger) {
  if (trigger) {
    _pendingRemeasure.add(trigger);
  }
  if (_remeasureQueued) {
    return;
  }
  _remeasureQueued = true;
  requestAnimationFrame(() => {
    _remeasureQueued = false;
    refreshScrollTriggers();
    _pendingRemeasure.forEach((pending) => {
      
      try {
        pending.refresh();
      } catch {
        ScrollTrigger.isRefreshing = false;
      }
    });
    _pendingRemeasure.clear();
  });
}

function trackStageResize(getStage, onChange) {
  let lastWidth = window.innerWidth;
  const measure = () => {
    const stage = getStage();
    return stage ? stage.getBoundingClientRect().height : 0;
  };
  let lastHeight = measure();

  const handler = debounce(() => {
    const width = window.innerWidth;
    const height = measure();
    const changed = width !== lastWidth || Math.abs(height - lastHeight) > 1;
    lastWidth = width;
    lastHeight = height;
    if (changed) {
      onChange();
    }
  }, 150);

  window.addEventListener("resize", handler);
  window.addEventListener("orientationchange", handler);
  return () => {
    window.removeEventListener("resize", handler);
    window.removeEventListener("orientationchange", handler);
  };
}

function killScrollTriggers(triggers, attempt) {
  const live = (Array.isArray(triggers) ? triggers : [triggers]).filter(
    Boolean,
  );
  if (!live.length) {
    return;
  }
  const tries = attempt || 0;
  if (
    tries < 10 &&
    typeof ScrollTrigger !== "undefined" &&
    (ScrollTrigger.isRefreshing || scrollTriggerBusy > 0)
  ) {
    /* `disable()` does not splice `_triggers`, so it is safe mid-refresh and
       stops these updating immediately — a deferred kill can never leave a
       live duplicate running alongside a freshly created replacement. The
       attempt cap keeps a flag left stuck by code outside this file from
       deferring the real kill forever. */
    live.forEach((trigger) => trigger.disable(false));
    requestAnimationFrame(() => killScrollTriggers(live, tries + 1));
    return;
  }
  live.forEach((trigger) => trigger.kill());
}


if (typeof ScrollTrigger !== "undefined") {
  const onViewportResize = debounce(() => remeasureAllScrollTriggers(), 150);
  window.addEventListener("resize", onViewportResize);
  window.addEventListener("orientationchange", onViewportResize);
}

/* ===== ScrollTrigger refresh on theme-editor section changes ===== */
document.addEventListener("shopify:section:load", () =>
  refreshScrollTriggers(),
);
document.addEventListener("shopify:section:reorder", () =>
  refreshScrollTriggers(),
);

/* ===== custom-barbers-header ===== */
if (!customElements.get("custom-barbers-header")) {
  customElements.define(
    "custom-barbers-header",
    class extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector(".barbers-header__hamburger");
        this.drawer = this.querySelector(".barbers-header__drawer");
        this.close = this.querySelector(".barbers-header__drawer-close");

        if (this.toggle && this.drawer) {
          this.onToggle = this.onToggle.bind(this);
          this.onKeyup = this.onKeyup.bind(this);
          this.toggle.addEventListener("click", this.onToggle);
          this.close?.addEventListener("click", this.onToggle);
          this.drawer.addEventListener("keyup", this.onKeyup);
        }

        this.lastScrollY = window.scrollY;
        this.onScroll = this.onScroll.bind(this);
        window.addEventListener("scroll", this.onScroll, { passive: true });
      }

      disconnectedCallback() {
        this.toggle?.removeEventListener("click", this.onToggle);
        this.close?.removeEventListener("click", this.onToggle);
        this.drawer?.removeEventListener("keyup", this.onKeyup);
        window.removeEventListener("scroll", this.onScroll);
        if (this.drawer?.hasAttribute("open")) {
          document.body.classList.remove("overflow-hidden");
        }
      }

      onScroll() {
        const currentScrollY = window.scrollY;
        const scrollingDown = currentScrollY > this.lastScrollY;
        const drawerOpen = this.drawer?.hasAttribute("open");

        if (
          !drawerOpen &&
          scrollingDown &&
          currentScrollY > this.offsetHeight
        ) {
          this.classList.add("barbers-header--hidden");
        } else {
          this.classList.remove("barbers-header--hidden");
        }

        this.lastScrollY = currentScrollY;
      }

      onKeyup(event) {
        if (event.code === "Escape" && this.drawer.hasAttribute("open")) {
          this.onToggle();
        }
      }

      onToggle() {
        const isOpen = this.drawer.hasAttribute("open");

        if (isOpen) {
          this.drawer.removeAttribute("open");
          document.body.classList.remove("overflow-hidden");
          if (typeof removeTrapFocus === "function") {
            removeTrapFocus(this.toggle);
          } else {
            this.toggle.focus();
          }
        } else {
          this.drawer.setAttribute("open", "");
          document.body.classList.add("overflow-hidden");
          if (typeof trapFocus === "function") {
            trapFocus(this.drawer, this.close || this.drawer);
          } else {
            (this.close || this.drawer).focus();
          }
        }

        this.toggle.setAttribute("aria-expanded", String(!isOpen));
      }
    },
  );
}

/* ===== custom-fade-up ===== */
if (!customElements.get("custom-fade-up")) {
  customElements.define(
    "custom-fade-up",
    class extends HTMLElement {
      connectedCallback() {
        this.scrollTriggers = [];
        this.init();
      }

      disconnectedCallback() {
        killScrollTriggers(this.scrollTriggers);
        this.scrollTriggers = [];
      }

      init() {
        if (
          typeof gsap === "undefined" ||
          typeof ScrollTrigger === "undefined"
        ) {
          return;
        }
        gsap.registerPlugin(ScrollTrigger);

        const targets = this.querySelectorAll("[data-fade-up]");
        if (!targets.length) {
          return;
        }

        const reduceMotion = window.matchMedia(
          "(prefers-reduced-motion: reduce)",
        ).matches;
        if (reduceMotion) {
          gsap.set(targets, { opacity: 1, y: 0 });
          return;
        }

        gsap.set(targets, { opacity: 0, y: 40 });

       
        const timeline =
          buildScrollTrigger(() =>
            gsap.timeline({
              scrollTrigger: {
                trigger: this,
                start: "top 85%",
                once: true,
              },
            }),
          ) || gsap.timeline();

        targets.forEach((target) => {
          const delay = parseFloat(target.dataset.fadeUpDelay || "0");
          timeline.to(
            target,
            { opacity: 1, y: 0, duration: 0.8, ease: "power2.out" },
            delay,
          );
        });

        if (timeline.scrollTrigger) {
          this.scrollTriggers.push(timeline.scrollTrigger);
        }
      }
    },
  );
}

/* ===== custom-swiper-slider ===== */
if (!customElements.get("custom-swiper-slider")) {
  customElements.define(
    "custom-swiper-slider",
    class extends HTMLElement {
      connectedCallback() {
        this.swiperEl = this.querySelector(".swiper");
        this.init();
      }

      disconnectedCallback() {
        this.autoplayObserver?.disconnect();
        this.swiper?.destroy(true, true);
      }

      init() {
        if (typeof Swiper === "undefined" || !this.swiperEl) {
          return;
        }

        const configTag = this.querySelector("script[data-swiper-config]");
        let config = {};
        try {
          config = JSON.parse(configTag ? configTag.textContent : "{}");
        } catch {
          config = {};
        }

        config.a11y = Object.assign({ enabled: true }, config.a11y);
        config.keyboard = Object.assign({ enabled: true }, config.keyboard);

       
        if (
          config.autoplay &&
          window.matchMedia("(prefers-reduced-motion: reduce)").matches
        ) {
          config.autoplay = false;
        }

        this.swiper = new Swiper(this.swiperEl, config);

        this.watchAutoplayVisibility(config);

        const loopActive = this.isLoopRunning();

       
        const requestedSlide = config.initialSlide;
        if (typeof requestedSlide === "number") {
          
          const currentSlide = loopActive
            ? this.swiper.realIndex
            : this.swiper.activeIndex;
          if (currentSlide !== requestedSlide) {
            if (loopActive && typeof this.swiper.slideToLoop === "function") {
              this.swiper.slideToLoop(requestedSlide, 0, false);
            } else {
              this.swiper.slideTo(requestedSlide, 0, false);
            }
          }
        }

        
        if (!loopActive) {
          const recenter = () => this.recenter();
          this.swiper.on("transitionEnd", recenter);
          this.swiper.on("touchEnd", recenter);
          setTimeout(recenter, 50);
        }
      }

      
      watchAutoplayVisibility(config) {
        if (!config.autoplay || !this.swiper?.autoplay) {
          return;
        }
        this.swiper.autoplay.stop();
        this.autoplayObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.swiper?.autoplay?.start();
              } else {
                this.swiper?.autoplay?.stop();
              }
            });
          },
          { threshold: 0.2 },
        );
        this.autoplayObserver.observe(this);
      }

      isLoopRunning() {
        const swiper = this.swiper;
        if (!swiper || !swiper.params.loop) {
          return false;
        }
        const perView =
          swiper.params.slidesPerView === "auto"
            ? swiper.slidesPerViewDynamic()
            : Math.ceil(parseFloat(swiper.params.slidesPerView));
        return swiper.slides.length >= perView + (swiper.loopedSlides || 0);
      }

      recenter() {
        const swiper = this.swiper;
        if (!swiper) {
          return;
        }
        const active = this.swiperEl.querySelector(".swiper-slide-active");
        if (!active) {
          return;
        }

        const containerRect = this.swiperEl.getBoundingClientRect();
        const activeRect = active.getBoundingClientRect();
        const delta =
          containerRect.left +
          containerRect.width / 2 -
          (activeRect.left + activeRect.width / 2);
        if (Math.abs(delta) < 0.5) {
          return;
        }

        swiper.setTransition(0);
        swiper.setTranslate(
          swiper.translate + delta * (swiper.rtlTranslate ? -1 : 1),
        );
      }
    },
  );
}

/* ===== custom-text-reveal ===== */
if (!customElements.get("custom-text-reveal")) {
  customElements.define(
    "custom-text-reveal",
    class extends HTMLElement {
      connectedCallback() {
        this.target = this.querySelector("[data-reveal-text]");
        this.reduceMotion = window.matchMedia(
          "(prefers-reduced-motion: reduce)",
        ).matches;

        if (
          !this.target ||
          typeof gsap === "undefined" ||
          typeof ScrollTrigger === "undefined" ||
          this.reduceMotion
        ) {
          return;
        }

        gsap.registerPlugin(ScrollTrigger);
        this.chars = this.splitChars(this.target);
        this.trigger = buildScrollTrigger(() =>
          ScrollTrigger.create({
            trigger: this,
            start: "top 85%",
            once: true,
            onEnter: () => this.reveal(),
          }),
        );
        if (!this.trigger) {
         
          this.reveal();
        }
      }

      disconnectedCallback() {
        killScrollTriggers(this.trigger);
      }

      
      splitChars(el) {
        const text = el.textContent;
        el.setAttribute("aria-label", text);
        el.textContent = "";
        const chars = [];
        Array.from(text).forEach((char) => {
          const clip = document.createElement("span");
          clip.setAttribute("aria-hidden", "true");
          clip.className = "mtb-heading__clip";
          const inner = document.createElement("span");
          inner.className = "mtb-heading__char";
          inner.textContent = char;
          clip.appendChild(inner);
          el.appendChild(clip);
          chars.push(inner);
        });
        return chars;
      }

      reveal() {
        gsap.to(this.chars, {
          yPercent: 0,
          opacity: 1,
          duration: 0.6,
          ease: "power3.out",
          stagger: 0.02,
        });
      }
    },
  );
}

/* ===== custom-read-more ===== */
if (!customElements.get("custom-read-more")) {
  customElements.define(
    "custom-read-more",
    class extends HTMLElement {
      connectedCallback() {
        this.text = this.querySelector(".tst-review-text");
        this.button = this.querySelector(".tst-readmore-btn");
        this.onClick = () => this.expand();
        this.button?.addEventListener("click", this.onClick);
      }

      disconnectedCallback() {
        this.button?.removeEventListener("click", this.onClick);
      }

      expand() {
        this.text?.classList.add("is-expanded");
        this.button?.setAttribute("aria-expanded", "true");
        this.button?.setAttribute("hidden", "");
      }
    },
  );
}

/* ===== custom-marquee ===== */
if (!customElements.get("custom-marquee")) {
  customElements.define(
    "custom-marquee",
    class extends HTMLElement {
      connectedCallback() {
        const firstGroup = this.querySelector(".ctm-marquee__group");
        if (!firstGroup) {
          return;
        }
        this.baseGroupHTML = firstGroup.innerHTML;
        this.lastWidth = 0;
        this.onResize = debounce(
          (entries) => this.build(entries[0].contentRect.width),
          150,
        );
        this.observer = new ResizeObserver(this.onResize);
        this.observer.observe(this.parentElement || this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

    
      build(containerWidth) {
        const width =
          containerWidth ||
          (this.parentElement
            ? this.parentElement.offsetWidth
            : this.offsetWidth);
        if (!width || Math.abs(width - this.lastWidth) < 1) {
          return;
        }
        this.lastWidth = width;
        this.innerHTML = "";
        const first = document.createElement("div");
        first.className = "ctm-marquee__group";
        first.setAttribute("aria-hidden", "false");
        first.innerHTML = this.baseGroupHTML;
        this.appendChild(first);

        const groupWidth = first.offsetWidth;
        if (!groupWidth) {
          return;
        }

        const count = Math.max(2, Math.ceil(width / groupWidth) + 1);
        for (let i = 1; i < count; i += 1) {
          const clone = document.createElement("div");
          clone.className = "ctm-marquee__group";
          clone.setAttribute("aria-hidden", "true");
          clone.innerHTML = this.baseGroupHTML;
          this.appendChild(clone);
        }

        this.style.setProperty("--marquee-shift", `-${groupWidth}px`);
      }
    },
  );
}

/* ===== custom-locations-scroll ===== */
if (!customElements.get("custom-locations-scroll")) {
  customElements.define(
    "custom-locations-scroll",
    class extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll("[data-loc-slide]"));
        this.images = this.slides.map((slide) =>
          slide.querySelector(".loc-photo__img, .loc-photo__placeholder"),
        );
        this.contents = Array.from(this.querySelectorAll("[data-loc-content]"));
        this.segs = Array.from(this.querySelectorAll(".loc-progress__seg"));
        this.stage = this.querySelector(".loc-stage");
        this.current = -1;
        this.reduceMotion = window.matchMedia(
          "(prefers-reduced-motion: reduce)",
        ).matches;

        if (
          !this.stage ||
          this.slides.length < 2 ||
          typeof gsap === "undefined" ||
          typeof ScrollTrigger === "undefined"
        ) {
          return;
        }

        gsap.registerPlugin(ScrollTrigger);
        this.onSegClick = this.onSegClick.bind(this);
        this.segs.forEach((seg) =>
          seg.addEventListener("click", this.onSegClick),
        );

        this.images.forEach((img) => {
          if (img) {
            gsap.set(img, { opacity: 1 });
          }
        });

        this.init();

        this.stopResizeWatch = trackStageResize(
          () => this.stage,
          () => remeasureScrollTrigger(this.trigger),
        );
      }

      disconnectedCallback() {
        this.stopResizeWatch?.();
        killScrollTriggers(this.trigger);
        this.contentTl?.kill();
        this.segs.forEach((seg) =>
          seg.removeEventListener("click", this.onSegClick),
        );
      }


      init(isRetry) {
        purgeTriggersFor(this.stage);
        this.trigger = buildScrollTrigger(() =>
          ScrollTrigger.create({
            trigger: this.stage,
            start: "top top",
            end: "bottom bottom",
            scrub: 0.35,
            onUpdate: (self) => this.onScroll(self.progress),
          }),
        );

        if (!this.trigger) {

          if (!isRetry) {
            requestAnimationFrame(() => this.isConnected && this.init(true));
          }
          return;
        }

        this.onScroll(this.trigger.progress);
      }


      onScroll(scrollProgress) {
        const total = this.slides.length;
        const raw = gsap.utils.clamp(0, total, scrollProgress * total);
        const index = Math.min(total - 1, Math.floor(raw));
        const localProgress = gsap.utils.clamp(0, 1, raw - index);

        this.updateActiveState(index);
        this.updateLayers(index, localProgress);
        this.updateFill(index, localProgress);
      }

      updateActiveState(index) {
        if (index === this.current) {
          return;
        }
        const previous = this.current;
        this.current = index;
        this.slides.forEach((slide) =>
          slide.classList.toggle(
            "is-active",
            Number(slide.dataset.locSlide) === index,
          ),
        );
        this.contents.forEach((content) =>
          content.classList.toggle(
            "is-active",
            Number(content.dataset.locContent) === index,
          ),
        );
        this.segs.forEach((seg) =>
          seg.classList.toggle(
            "is-active",
            Number(seg.dataset.locGoto) === index,
          ),
        );
        this.swapContent(previous, index);
      }

      /** First paint: instant */
      swapContent(previousIndex, index) {
        if (previousIndex === -1) {
          this.contents.forEach((content, i) => {
            gsap.set(content, { opacity: i === index ? 1 : 0, yPercent: 0 });
          });
          return;
        }

        const duration = this.reduceMotion ? 0.01 : 0.35;
        const direction = index > previousIndex ? 1 : -1;
        const outContent = this.contents[previousIndex];
        const inContent = this.contents[index];


        this.contentTl?.kill();


        this.contents.forEach((content, i) => {
          if (i !== previousIndex && i !== index) {
            gsap.set(content, { opacity: 0 });
          }
        });

        const tl = gsap.timeline({ defaults: { overwrite: "auto" } });
        this.contentTl = tl;

        if (outContent) {
          tl.to(outContent, {
            opacity: 0,
            ...(this.reduceMotion ? {} : { yPercent: -8 * direction }),
            duration: duration * 0.5,
            ease: "power2.in",
          });
        }
        if (inContent) {

          if (!gsap.isTweening(inContent)) {
            gsap.set(
              inContent,
              this.reduceMotion
                ? { opacity: 0 }
                : { opacity: 0, yPercent: 8 * direction },
            );
          }
          tl.to(inContent, {
            opacity: 1,
            yPercent: 0,
            duration: duration * 0.5,
            ease: "power2.out",
          });
        }
      }


      updateLayers(index, localProgress) {
        this.images.forEach((img, i) => {
          if (!img || i === 0) {
            return;
          }
          const reveal = gsap.utils.clamp(
            0,
            1,
            index + localProgress - (i - 1),
          );
          gsap.set(img, { clipPath: `inset(${(1 - reveal) * 100}% 0 0 0)` });
        });
      }

      updateFill(activeIndex, localProgress) {
        const clamped = Math.max(0, Math.min(1, localProgress));
        this.segs.forEach((seg) => {
          const fill = seg.querySelector(".loc-progress__fill");
          if (!fill) {
            return;
          }
          const segIndex = Number(seg.dataset.locGoto);
          const pct =
            segIndex < activeIndex
              ? 100
              : segIndex === activeIndex
                ? clamped * 100
                : 0;
          fill.style.width = `${pct}%`;
        });
      }

      onSegClick(event) {
        const target = Number(event.currentTarget.dataset.locGoto);
        const y =
          this.trigger.start +
          (target / this.slides.length) *
            (this.trigger.end - this.trigger.start);
        window.scrollTo({ top: y, behavior: "smooth" });
      }
    },
  );
}

/* ===== custom-barbers-gallery ===== */
if (!customElements.get("custom-barbers-gallery")) {
  customElements.define(
    "custom-barbers-gallery",
    class extends HTMLElement {
      connectedCallback() {
        this.gallery = this.querySelector(".mtb-gallery");
        this.strip = this.querySelector("[data-mtb-strip]");
        this.thumbs = Array.from(this.querySelectorAll(".mtb-thumb"));
        this.viewer = this.querySelector("[data-mtb-viewer]");
        this.viewerTrack = this.querySelector("[data-mtb-viewer-track]");
        this.viewerImgs = Array.from(this.querySelectorAll(".mtb-viewer__img"));
        this.viewerSlides = Array.from(
          this.querySelectorAll(".mtb-viewer__slide"),
        );
        this.nameplate = this.querySelector("[data-mtb-nameplate]");
        this.nameplateName = this.querySelector("[data-mtb-nameplate-name]");
        this.nameplateLocation = this.querySelector(
          "[data-mtb-nameplate-location]",
        );
        this.videoButton = this.querySelector("[data-mtb-play]");
        
        const scope = this.closest(".mtb-hero") || this;
        this.prevBtn = scope.querySelector("[data-mtb-prev]");
        this.nextBtn = scope.querySelector("[data-mtb-next]");
        if (
          this.thumbs.length < 2 ||
          !this.strip ||
          !this.gallery ||
          !this.viewerTrack
        ) {
          return;
        }

        const initialIndex = this.thumbs.findIndex(
          (thumb) => thumb.dataset.active === "true",
        );
        this.activeIndex = initialIndex === -1 ? 0 : initialIndex;
        this.raw = this.activeIndex;
        this.rawTarget = this.activeIndex;
        this.swiperMode = false;
        this.activeVideoBlockId = null;

        this.onClick = this.onClick.bind(this);
        this.onPrevClick = this.onPrevClick.bind(this);
        this.onNextClick = this.onNextClick.bind(this);
        this.onPlayClick = this.onPlayClick.bind(this);
        this.pauseAutoplay = this.pauseAutoplay.bind(this);
        this.resumeAutoplay = this.resumeAutoplay.bind(this);
        this.videoButton?.addEventListener("click", this.onPlayClick);
        this.stage = this.closest(".mtb-stage");
        this.stopResizeWatch = trackStageResize(
          () => this.stage,
          () => this.layout(),
        );

        this.layout();
        this.updateActiveMeta(this.activeIndex, true);
        this.startTicker();
        this.initScroll();
        this.awaitReady();
      }

      disconnectedCallback() {
        this.stopResizeWatch?.();
        this.stopTicker();
        this.stopAutoplay();
        this.modeCleanup?.();
        this.isDesktopQuery?.removeEventListener("change", this.applyMode);
        this.reduceMotionQuery?.removeEventListener("change", this.applyMode);
        this.videoButton?.removeEventListener("click", this.onPlayClick);
      }

      onPlayClick() {
        if (!this.activeVideoBlockId) {
          return;
        }
        const modal = document.getElementById(this.dataset.videoModalId);
        if (!modal) {
          return;
        }
        let activeMedia = null;
        modal.querySelectorAll(".mtb-video-modal__media").forEach((media) => {
          const isActive = media.dataset.blockId === this.activeVideoBlockId;
          media.hidden = !isActive;
          if (isActive) {
            activeMedia = media;
          } else {
            media.querySelector("video")?.pause();
          }
        });
        /* modal.show() calls window.pauseAllMedia(), which pauses every
         * <video> on the page — loadContent() (which starts playback) must
         * run after show(), or the just-started video gets paused instantly. */
        modal.show(this.videoButton);
        activeMedia?.loadContent?.();
      }

      async awaitReady() {
        const images = [
          ...this.thumbs.map((thumb) => thumb.querySelector("img")),
          ...this.viewerImgs,
        ].filter(Boolean);
        await Promise.all(
          images.map((img) => {
            if (img.complete) {
              return Promise.resolve();
            }
            return img.decode
              ? img.decode().catch(() => {})
              : new Promise((resolve) =>
                  img.addEventListener("load", resolve, { once: true }),
                );
          }),
        );
        if (document.fonts?.ready) {
          await document.fonts.ready;
        }
        this.layout();
      }

      layout() {
        if (this.swiperMode) {
          return;
        }
        const first = this.thumbs[0];

        const stripStyles = getComputedStyle(this.strip);
        const gap = parseFloat(stripStyles.columnGap || stripStyles.gap) || 12;

        this.thumbWidth = first.getBoundingClientRect().width;
        this.pitch = this.thumbWidth + gap;
        this.viewerPitch = this.viewer.getBoundingClientRect().width;

        this.thumbShift = Math.max(0, (this.viewerPitch - this.thumbWidth) / 2);
        this.viewerSlides.forEach((slide) => {
          slide.style.width = `${this.viewerPitch}px`;
        });
        this.setStripX(this.raw);
        this.setThumbFocus(this.raw);
        this.setViewerX(this.raw, true);
      }

      initScroll() {
        if (!this.stage) {
          this.reduceMotion = window.matchMedia(
            "(prefers-reduced-motion: reduce)",
          ).matches;
          this.thumbs.forEach((thumb) =>
            thumb.addEventListener("click", this.onClick),
          );
          return;
        }
        this.isDesktopQuery = window.matchMedia("(min-width: 990px)");
        this.reduceMotionQuery = window.matchMedia(
          "(prefers-reduced-motion: reduce)",
        );
        this.applyMode = this.applyMode.bind(this);
        this.isDesktopQuery.addEventListener("change", this.applyMode);
        this.reduceMotionQuery.addEventListener("change", this.applyMode);
        this.applyMode();
      }

      /** Tears down whatever  */
      applyMode() {
        this.modeCleanup?.();
        this.modeCleanup = null;

        const isDesktop = this.isDesktopQuery.matches;
        const reduceMotion = this.reduceMotionQuery.matches;
        this.reduceMotion = reduceMotion;

        if (!isDesktop) {
          this.modeCleanup = this.initMobileSwiper();
          return;
        }

        if (reduceMotion) {
          this.thumbs.forEach((thumb) =>
            thumb.addEventListener("click", this.onClick),
          );
          this.modeCleanup = () => {
            this.thumbs.forEach((thumb) =>
              thumb.removeEventListener("click", this.onClick),
            );
          };
          return;
        }

        this.modeCleanup = this.initDesktopCarousel();
      }

      initDesktopCarousel() {
        this.thumbs.forEach((thumb) =>
          thumb.addEventListener("click", this.onClick),
        );
        this.prevBtn?.addEventListener("click", this.onPrevClick);
        this.nextBtn?.addEventListener("click", this.onNextClick);
        this.updateNavButtons();

        this.gallery.addEventListener("mouseenter", this.pauseAutoplay);
        this.gallery.addEventListener("mouseleave", this.resumeAutoplay);
        this.autoplayPaused = false;
        this.startAutoplay();

        return () => {
          this.stopAutoplay();
          this.gallery.removeEventListener("mouseenter", this.pauseAutoplay);
          this.gallery.removeEventListener("mouseleave", this.resumeAutoplay);
          this.thumbs.forEach((thumb) =>
            thumb.removeEventListener("click", this.onClick),
          );
          this.prevBtn?.removeEventListener("click", this.onPrevClick);
          this.nextBtn?.removeEventListener("click", this.onNextClick);
        };
      }

      startAutoplay() {
        if (this.reduceMotion || this.autoplayPaused || this.thumbs.length < 2) {
          return;
        }
        this.stopAutoplay();
        this.autoplayId = setInterval(() => {
          const total = this.thumbs.length;
          const next = (Math.round(this.activeIndex) + 1) % total;
          this.animateTo(next);
        }, 4000);
      }

      stopAutoplay() {
        if (this.autoplayId) {
          clearInterval(this.autoplayId);
          this.autoplayId = null;
        }
      }

      /** Hovering the gallery (or leaving it) pauses/resumes autoplay — lets a visitor actually read a card instead of it changing under the cursor. */
      pauseAutoplay() {
        this.autoplayPaused = true;
        this.stopAutoplay();
      }

      resumeAutoplay() {
        this.autoplayPaused = false;
        this.startAutoplay();
      }

      initMobileSwiper() {
        if (typeof Swiper === "undefined" || !this.viewer) {
          this.thumbs.forEach((thumb) =>
            thumb.addEventListener("click", this.onClick),
          );
          return () => {
            this.thumbs.forEach((thumb) =>
              thumb.removeEventListener("click", this.onClick),
            );
          };
        }

        this.swiperMode = true;
        this.strip.classList.add("hidden");
        this.viewer.classList.add("swiper");
        this.viewer.removeAttribute("aria-hidden");
        this.viewerTrack.classList.add("swiper-wrapper");
        this.viewerSlides.forEach((slide) => {
          slide.classList.add("swiper-slide");
          slide.style.width = "";
        });
        this.viewerImgs.forEach((img, i) => {
          img.style.transform = "";
          const thumbImg = this.thumbs[i]?.querySelector("img");
          if (thumbImg?.alt) {
            img.alt = thumbImg.alt;
          }
        });
        this.thumbs.forEach((thumb) => {
          thumb.style.opacity = "";
          thumb.style.transform = "";
          const img = thumb.querySelector("img");
          if (img) {
            img.style.transform = "";
          }
        });

        const swiper = new Swiper(this.viewer, {
          slidesPerView: 1,
          grabCursor: true,
          initialSlide: this.activeIndex,
          a11y: { enabled: true },
          keyboard: { enabled: true },
          navigation: { prevEl: this.prevBtn, nextEl: this.nextBtn },

          autoplay: this.reduceMotion
            ? false
            : {
                delay: 4000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              },
          on: {
            slideChange: (instance) =>
              this.updateActiveMeta(instance.activeIndex, false),
          },
        });
        this.mobileSwiper = swiper;
        this.updateActiveMeta(this.activeIndex, true);

        return () => {
          swiper.destroy(true, true);
          this.mobileSwiper = null;
          this.swiperMode = false;
          this.strip.classList.remove("hidden");
          this.viewer.classList.remove("swiper");
          this.viewer.setAttribute("aria-hidden", "true");
          this.viewerTrack.classList.remove("swiper-wrapper");
          this.viewerSlides.forEach((slide) => {
            slide.classList.remove("swiper-slide");
            slide.style.width = "";
          });
          this.viewerImgs.forEach((img) => {
            img.style.transform = "";
            img.setAttribute("alt", "");
          });
          this.thumbs.forEach((thumb) => {
            thumb.style.opacity = "";
            thumb.style.transform = "";
            const img = thumb.querySelector("img");
            if (img) {
              img.style.transform = "";
            }
          });
          this.layout();
        };
      }

      startTicker() {

        const step = () => {
          this.raw = this.rawTarget;
          this.render(this.raw);
          this.rafId = requestAnimationFrame(step);
        };
        this.rafId = requestAnimationFrame(step);
      }

      stopTicker() {
        if (this.rafId) {
          cancelAnimationFrame(this.rafId);
          this.rafId = null;
        }
      }

      render(raw) {
        if (this.swiperMode) {
          return;
        }
        this.setStripX(raw);
        this.setViewerX(raw, false);
        this.setThumbFocus(raw);

        const index = Math.round(raw);
        if (index !== this.activeIndex) {
          this.updateActiveMeta(index, false);
        }
      }


      setStripX(raw) {
        if (!this.pitch) {
          return;
        }
        const x = -(raw * this.pitch) - this.thumbWidth / 2;
        if (typeof gsap === "undefined") {
          this.strip.style.transform = `translate(${x}px, -50%)`;
          return;
        }

        gsap.set(this.strip, { x, yPercent: -50 });
      }


      setViewerX(raw, instant) {
        if (!this.viewerPitch) {
          return;
        }
        const x = -(raw * this.viewerPitch);
        if (typeof gsap === "undefined" || instant) {
          this.viewerTrack.style.transform = `translateX(${x}px)`;
          return;
        }
        gsap.set(this.viewerTrack, { x });
      }

      setThumbFocus(raw) {
        const clamp =
          typeof gsap === "undefined"
            ? (min, max, value) => Math.min(max, Math.max(min, value))
            : gsap.utils.clamp;
        const shift = this.thumbShift || 0;

        this.thumbs.forEach((thumb, i) => {
          const delta = i - raw;
          thumb.style.opacity = String(
            clamp(0.45, 1, 1 - Math.abs(delta) * 0.6),
          );

          const offset = Math.sign(delta) * shift;
          if (typeof gsap === "undefined") {
            thumb.style.transform = `translateX(${offset}px)`;
            return;
          }
          gsap.set(thumb, { x: offset });
        });
      }

      /** Click-to-navigate — a thumbnail, active in every mode. */
      onClick(event) {
        const index = Number(event.currentTarget.dataset.index);
        this.animateTo(index);
      }

      onPrevClick() {
        this.animateTo(this.activeIndex - 1);
      }

      onNextClick() {
        this.animateTo(this.activeIndex + 1);
      }

      animateTo(index) {
        const total = this.thumbs.length;
        const target = Math.max(0, Math.min(total - 1, index));
        if (target === this.activeIndex && target === this.rawTarget) {
          return;
        }

        if (typeof gsap === "undefined" || this.reduceMotion) {
          this.raw = target;
          this.rawTarget = target;
          this.setStripX(target);
          this.setViewerX(target, true);
          this.setThumbFocus(target);
          this.updateActiveMeta(target, true);
          return;
        }

        gsap.to(this, {
          rawTarget: target,
          duration: 0.6,
          ease: "power2.inOut",
          overwrite: "auto",
        });

        this.startAutoplay();
      }

      updateNavButtons() {
        if (this.prevBtn) {
          this.prevBtn.disabled = this.activeIndex <= 0;
        }
        if (this.nextBtn) {
          this.nextBtn.disabled = this.activeIndex >= this.thumbs.length - 1;
        }
      }

      updateActiveMeta(index, instant) {
        this.activeIndex = index;
        this.updateNavButtons();
        const duration = instant || this.reduceMotion ? 0 : 0.3;

        if (!this.swiperMode) {
          this.viewerImgs.forEach((img) =>
            img.setAttribute("aria-hidden", "true"),
          );
          this.viewerImgs[index]?.setAttribute("aria-hidden", "false");
        }

        this.updateNameplate(index, instant, duration);
        this.updateVideoButton(index);
      }

      updateVideoButton(index) {
        if (!this.videoButton) {
          return;
        }
        const thumb = this.thumbs[index];
        const blockId = thumb?.dataset.videoBlock || null;
        this.activeVideoBlockId = blockId;
        this.videoButton.hidden = !blockId;
        if (blockId) {
          const name = thumb?.dataset.name;
          this.videoButton.setAttribute(
            "aria-label",
            name ? `Play ${name}'s video` : "Play video",
          );
        }
      }

      updateNameplate(index, instant, duration) {
        if (!this.nameplate) {
          return;
        }
        const thumb = this.thumbs[index];
        const name = thumb?.dataset.name;
        const location = thumb?.dataset.location;
        const show = Boolean(name);

        if (show) {
          if (this.nameplateName) {
            this.nameplateName.textContent = name;
          }
          if (this.nameplateLocation) {
            this.nameplateLocation.textContent = location || "";
          }
        }

        if (typeof gsap === "undefined") {
          this.nameplate.style.display = show ? "flex" : "none";
          this.nameplate.style.opacity = show ? "1" : "0";
          return;
        }

        if (show) {
          this.nameplate.style.display = "flex";
        }
        gsap.to(this.nameplate, {
          autoAlpha: show ? 1 : 0,
          duration,
          delay: show && !instant ? duration : 0,
          ease: "power1.out",
          onComplete: () => {
            if (!show) {
              this.nameplate.style.display = "none";
            }
          },
        });
      }
    },
  );
}

/* ===== custom-services-grid ===== */
if (!customElements.get("custom-services-grid")) {
  customElements.define(
    "custom-services-grid",
    class extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll("[data-sg-tab]"));
        this.items = Array.from(this.querySelectorAll("[data-sg-category]"));
        this.onTabClick = (event) => this.selectTab(event.currentTarget);
        this.tabs.forEach((tab) =>
          tab.addEventListener("click", this.onTabClick),
        );
      }

      disconnectedCallback() {
        this.tabs.forEach((tab) =>
          tab.removeEventListener("click", this.onTabClick),
        );
      }

      selectTab(tab) {
        this.tabs.forEach((t) => t.classList.remove("is-active"));
        tab.classList.add("is-active");

        const category = tab.getAttribute("data-sg-tab");
        this.items.forEach((item) => {
          item.hidden =
            category !== "all" &&
            item.getAttribute("data-sg-category") !== category;
        });
      }
    },
  );
}

/* ===== custom-barbers-grid ===== */
if (!customElements.get("custom-barbers-grid")) {
  customElements.define(
    "custom-barbers-grid",
    class extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll("[data-brg-tab]"));
        this.items = Array.from(this.querySelectorAll("[data-brg-category]"));
        this.onTabClick = (event) => this.selectTab(event.currentTarget);
        this.tabs.forEach((tab) =>
          tab.addEventListener("click", this.onTabClick),
        );

        this.playCards = Array.from(
          this.querySelectorAll("[data-brg-card][data-brg-video]"),
        );
        this.onPlayClick = this.onPlayClick.bind(this);
        this.onPlayKeydown = this.onPlayKeydown.bind(this);
        this.playCards.forEach((card) => {
          card.addEventListener("click", this.onPlayClick);
          card.addEventListener("keydown", this.onPlayKeydown);
        });
      }

      disconnectedCallback() {
        this.tabs.forEach((tab) =>
          tab.removeEventListener("click", this.onTabClick),
        );
        this.playCards.forEach((card) => {
          card.removeEventListener("click", this.onPlayClick);
          card.removeEventListener("keydown", this.onPlayKeydown);
        });
      }

      selectTab(tab) {
        this.tabs.forEach((t) => t.classList.remove("is-active"));
        tab.classList.add("is-active");

        const location = tab.getAttribute("data-brg-tab");
        this.items.forEach((item) => {
          item.hidden =
            location !== "all" &&
            item.getAttribute("data-brg-category") !== location;
        });
      }

      onPlayKeydown(event) {
        if (event.key !== "Enter" && event.key !== " ") {
          return;
        }
        event.preventDefault();
        this.onPlayClick(event);
      }

      onPlayClick(event) {
        const card = event.currentTarget;
        const barberId = card?.dataset.brgVideo;
        if (!barberId) {
          return;
        }
        const modal = document.getElementById(this.dataset.videoModalId);
        if (!modal) {
          return;
        }
        let activeMedia = null;
        modal.querySelectorAll(".brg-modal__media").forEach((media) => {
          const isActive = media.dataset.barberId === barberId;
          media.hidden = !isActive;
          if (isActive) {
            activeMedia = media;
          } else {
            media.querySelector("video")?.pause();
          }
        });
        /* modal.show() calls window.pauseAllMedia(), which pauses every
         * <video> on the page — loadContent() (which starts playback) must
         * run after show(), or the just-started video gets paused instantly. */
        modal.show(card);
        activeMedia?.loadContent?.();
      }
    },
  );
}

/* ===== custom-gallery-filter ===== */
if (!customElements.get("custom-gallery-filter")) {
  customElements.define(
    "custom-gallery-filter",
    class extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector("[data-gal-filter-toggle]");
        this.panel = this.querySelector("[data-gal-filter-panel]");
        this.label = this.querySelector("[data-gal-filter-label]");
        this.options = Array.from(
          this.querySelectorAll("[data-gal-filter-option]"),
        );
        this.items = Array.from(this.querySelectorAll("[data-gal-service]"));
        this.pattern = (this.dataset.galPattern || "")
          .split(",")
          .filter(Boolean);
        this.patternMobile = (this.dataset.galPatternMobile || "")
          .split(",")
          .filter(Boolean);

        this.onToggleClick = () => this.setOpen(this.panel.hidden);
        this.onOptionClick = (event) =>
          this.selectOption(event.currentTarget);
        this.onDocumentClick = (event) => {
          if (!this.contains(event.target)) {
            this.setOpen(false);
          }
        };
        this.onKeydown = (event) => {
          if (event.key === "Escape") {
            this.setOpen(false);
            this.toggle.focus();
          }
        };

        if (this.toggle && this.panel) {
          this.toggle.addEventListener("click", this.onToggleClick);
          this.options.forEach((option) =>
            option.addEventListener("click", this.onOptionClick),
          );
          document.addEventListener("click", this.onDocumentClick);
          this.addEventListener("keydown", this.onKeydown);
        }
      }

      disconnectedCallback() {
        this.toggle?.removeEventListener("click", this.onToggleClick);
        this.options.forEach((option) =>
          option.removeEventListener("click", this.onOptionClick),
        );
        document.removeEventListener("click", this.onDocumentClick);
        this.removeEventListener("keydown", this.onKeydown);
      }

      setOpen(open) {
        this.panel.hidden = !open;
        this.toggle.setAttribute("aria-expanded", String(open));
      }

      selectOption(option) {
        const value = option.getAttribute("data-gal-filter-option");

        this.options.forEach((opt) => {
          const isActive = opt === option;
          opt.classList.toggle("is-active", isActive);
          opt.closest("[role='option']")?.setAttribute(
            "aria-selected",
            String(isActive),
          );
        });

        if (this.label) {
          this.label.textContent = option.textContent.trim();
        }

        this.items.forEach((item) => {
          item.hidden =
            value !== "" && item.getAttribute("data-gal-service") !== value;
        });

        this.updateSpans();
        this.setOpen(false);
      }

      updateSpans() {
        if (!this.pattern.length && !this.patternMobile.length) {
          return;
        }

        const visible = this.items.filter((item) => !item.hidden);

        visible.forEach((item, index) => {
          if (this.pattern.length) {
            item.style.setProperty(
              "--gal-span",
              this.pattern[index % this.pattern.length],
            );
          }
          if (this.patternMobile.length) {
            item.style.setProperty(
              "--gal-span-mobile",
              this.patternMobile[index % this.patternMobile.length],
            );
          }
        });
      }
    },
  );
}

/* ===== ajax contact/sponsorship forms (no reload, no scroll jump) ===== */
(function () {
  const FORM_SELECTOR = '.ctf-section form[data-type="contact"]';

  async function handleSubmit(event) {
    const form = event.target;
    if (!(form instanceof HTMLElement) || !form.matches(FORM_SELECTOR)) {
      return;
    }

    event.preventDefault();

    const section = form.closest(".shopify-section");
    const submitBtn = form.querySelector('button[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;

    try {
      const response = await fetch(form.action, {
        method: "POST",
        body: new FormData(form),
      });
      const html = await response.text();

      if (section) {
        const doc = new DOMParser().parseFromString(html, "text/html");
        const newSection = doc.getElementById(section.id);
        if (newSection) {
          section.innerHTML = newSection.innerHTML;
          return;
        }
      }

      window.location.href = form.action;
    } catch (error) {
      form.submit();
    } finally {
      if (submitBtn) submitBtn.disabled = false;
    }
  }

  document.addEventListener("submit", handleSubmit);
})();

